const comment = {
	name: 'Comment | Comments',
	icon: 'fas fa-comment',
	fields: {},
}

export default comment
